
import { Observer } from 'mobx-vue'
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'

@Observer
@Component({
  components: {}
})
export default class MyLayout extends Vue {
  @Prop({ default: () => [] }) menuList: Array<{
    label: string
    value: string
  }>
  @Prop({ required: true }) menuKey: string

  @Prop({ default: false }) customRightContent: boolean

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
